<template>
    <div class="dice-roll">
        <div id="canvas" ref="canvas"></div>
    </div>
</template>

<script>
import RollDice from "../../dice/main";

export default {
    props: {
        values: {
            type: Array,
            required: true
        },
        color: {
            type: String,
            default: '#fe5616'
        }
    },

    data() {
        return {
            roll: null
        }
    },
    mounted() {
            this.roll = new RollDice(this.$refs.canvas, this.values, this.color);
            this.roll.roll();

    },
    beforeDestroy() {
        this.roll.unbindEvents();
    },
    computed: {

    },

    methods: {

    }
}
</script>

<style scoped>
    .dice-roll {
        position: fixed;
        z-index: 999;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        pointer-events: none;
    }
</style>
